<template>
    <el-tabs v-model="model" :type="type" :closable="closable" :tab-position="tabPosition" :stretch="stretch"
        :before-leave="beforeLeave" @tab-click="onTabClick" @tab-change="onTabChange" @tab-remove="onTabRemove"
        @tab-add="onTabAdd" :addable="addable" class="orion-tabs">
        <template v-if="addable" #add-icon>
            <slot name="right-extra"></slot>
        </template>
        <slot></slot>
    </el-tabs>
</template>

<script lang="ts" setup>
import type { TabPaneName, TabsPaneContext, TabsProps } from './tabs'
import { ElTabs } from 'element-plus'
import { computed, useSlots } from 'vue'

defineOptions({
    name: 'OTabs',
    inheritAttrs: false
})
const slots = useSlots()

const { type = 'card', closable = false, tabPosition = 'top', stretch = false, beforeLeave = () => true } = defineProps<TabsProps>()
const model = defineModel<TabPaneName>()
const addable = computed(() => {
    return (slots['right-extra']) && (['top', 'bottom'].indexOf(tabPosition) > -1)
})

const emit = defineEmits<{
    (e: 'tab-click', pane: TabsPaneContext, ev: Event): void
    (e: 'tab-change', name: TabPaneName): void
    (e: 'tab-remove', name: TabPaneName): void
    (e: 'tab-add'): void
}>()
const onTabClick = (pane: TabsPaneContext, ev: Event) => {
    emit('tab-click', pane, ev)
}
const onTabChange = (name: TabPaneName) => {
    emit('tab-change', name)
}
const onTabRemove = (name: TabPaneName) => {
    emit('tab-remove', name)
}
const onTabAdd = () => {
    emit('tab-add')
}
</script>